const DAYS_EXPIRE = 30
const PREFERENCE_COOKIE_NAME = 've_cookie_preferences'

export default function cookiesManager(props) {
    return {
        isOpen: false,
        isPreferencesOpen: false,
        categories: props.categories || [],
        daysToExpire: props.daysToExpire ?? DAYS_EXPIRE,
        preferences: {},

        init() {
            this.open = false
            this.loadPreferences()
            this.isOpen = !this.hasPreferences()
            this.isPreferencesOpen = false
            this.enforceCookiePreferences()
        },

        hasPreferences() {
            return this.getCookie(PREFERENCE_COOKIE_NAME) !== null
        },

        loadPreferences() {
            const savedPreferences = this.getCookie(PREFERENCE_COOKIE_NAME)
            if (savedPreferences) {
                try {
                    this.preferences = JSON.parse(savedPreferences)
                } catch (e) {
                    this.preferences = {}
                }
            } else {
                this.categories.forEach((category) => {
                    this.preferences[category.id] = category.required
                })
            }
        },

        enforceCookiePreferences() {
            setTimeout(() => {
                if (this.hasPreferences()) {
                    this.deleteRejectedCookies()
                }
            }, 1000)
        },

        acceptAll() {
            this.categories.forEach((category) => {
                this.preferences[category.id] = true
            })
            this.savePreferencesToCookie()
            this.isOpen = false
            this.isPreferencesOpen = false
        },

        denyAll() {
            this.categories.forEach((category) => {
                this.preferences[category.id] = category.required
            })
            this.savePreferencesToCookie()
            this.deleteNonRequiredCookies()
            this.isOpen = false
            this.isPreferencesOpen = false
        },

        savePreferences() {
            this.categories.forEach((category) => {
                if (!category.required) {
                    const toggle = document.querySelector(`[data-category="${category.id}"]`)
                    if (toggle) {
                        this.preferences[category.id] = toggle.checked
                    }
                }
            })

            this.savePreferencesToCookie()
            this.deleteRejectedCookies()
            this.isOpen = false
            this.isPreferencesOpen = false
        },

        savePreferencesToCookie() {
            this.setCookie(PREFERENCE_COOKIE_NAME, JSON.stringify(this.preferences), this.daysToExpire)
        },

        deleteRejectedCookies() {
            this.categories.forEach((category) => {
                if (!this.preferences[category.id]) {
                    this.deleteCategoryCookies(category)
                }
            })
        },

        deleteNonRequiredCookies() {
            this.categories.forEach((category) => {
                if (!category.required) {
                    this.deleteCategoryCookies(category)
                }
            })
        },

        deleteCategoryCookies(category) {
            if (category.startsWith) {
                this.deleteCookiesByPrefix(category.startsWith)
            }

            if (category.cookies && Array.isArray(category.cookies)) {
                category.cookies.forEach((cookieName) => {
                    this.deleteCookie(cookieName)
                })
            }
        },

        deleteCookiesByPrefix(prefix) {
            const cookies = document.cookie.split(';')
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim()
                const cookieName = cookie.split('=')[0]
                if (cookieName.startsWith(prefix)) {
                    this.deleteCookie(cookieName)
                }
            }
        },

        enableCategory(categoryId) {
            this.preferences[categoryId] = true
            this.savePreferencesToCookie()
        },

        disableCategory(categoryId) {
            const category = this.categories.find((c) => c.id === categoryId)
            if (category && !category.required) {
                this.preferences[categoryId] = false
                this.savePreferencesToCookie()
                this.deleteCategoryCookies(category)
            }
        },

        openModal() {
            this.isOpen = true
            this.isPreferencesOpen = false
        },

        closeModal() {
            this.isOpen = false
            this.isPreferencesOpen = false
        },

        openPreferences() {
            this.isOpen = true
            this.isPreferencesOpen = true
        },

        closePreferences() {
            this.isPreferencesOpen = false
        },

        setCookie(name, value, days) {
            const date = new Date()
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
            const expires = '; expires=' + date.toUTCString()
            document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax'
        },

        getCookie(name) {
            const nameEQ = name + '='
            const ca = document.cookie.split(';')
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i]
                while (c.charAt(0) === ' ') c = c.substring(1, c.length)
                if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length))
            }
            return null
        },

        deleteCookie(name) {
            document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        },
    }
}
